import React from "react";
import { Loader2, Eye, X } from "lucide-react";

export const NotificationActions = ({
  notification,
  isLoading,
  onMarkAsRead,
  onRemove,
  t,
}) => (
  <div className="flex items-center gap-1 flex-shrink-0">
    {!notification.read && (
      <button
        type="button"
        onClick={() => onMarkAsRead(notification.id)}
        title={t("markAsRead") || "Mark as read"}
        disabled={isLoading}
        className="p-2 text-slate-500 hover:text-slate-700 hover:bg-slate-200 rounded-lg transition-colors disabled:opacity-50"
      >
        {isLoading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Eye className="h-4 w-4" />
        )}
      </button>
    )}

    <button
      type="button"
      onClick={() => onRemove(notification.id)}
      title={t("remove") || "Remove"}
      disabled={isLoading}
      className="p-2 text-slate-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50"
    >
      {isLoading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <X className="h-4 w-4" />
      )}
    </button>
  </div>
);
